import { useEffect } from "react";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { setLenis, scrollToId } from "@/lib/scroll";
import { AppRoutes } from "@/AppRoutes";

const IntroLoader = () => (
  <motion.div
    data-testid="intro-loader"
    className="fixed inset-0 z-[60] flex items-center justify-center bg-nuit pointer-events-none"
    initial={{ y: 0 }}
    animate={{ y: "-100%" }}
    transition={{ delay: 1.05, duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
    aria-hidden="true"
  >
    <div className="overflow-hidden">
      <motion.img
        src="/images/logo-white.png"
        alt="LIMEN — Aménagement & Rénovation"
        className="h-16 w-auto"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ delay: 0.15, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      />
    </div>
  </motion.div>
);

const HashScroll = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 500);
      return () => clearTimeout(t);
    }
  }, [location]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-casse font-body text-anthracite" data-testid="app-root">
        <IntroLoader />
        <HashScroll />
        <AppRoutes />
        <Toaster position="top-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
